export function extractSrcSetData(srcSet: string | undefined | null) {
    if (srcSet == null) return srcSet;
    const result: { url: string; size: number; unit: "w" | "x" }[] = [];
    for (const match of srcSet.matchAll(
        /(?<s>[^ ]+)[ ]+(?<value>[0-9\.]+)(?<unit>[wx])\s*(,?)\s*/g
    )) {
        if (match == null || match.groups == null) continue;
        const unit = match.groups.unit;
        if (unit != "w" && unit != "x") continue;
        result.push({
            url: match.groups.s,
            size: parseInt(match.groups.value),
            unit: unit,
        });
    }
    return result;
}

function srcSetDataToString(data: {
    url: string;
    size: number;
    unit: "w" | "x";
}) {
    return `${data.url} ${data.size}${data.unit}`;
}

export function patchSrcSet(
    srcSet: ReturnType<typeof extractSrcSetData> | string | undefined | null,
    fixedWidth: number | undefined | null,
    scaleOfScreen: number,
    pictureUrl: string
) {
    if (!Array.isArray(srcSet)) {
        if (typeof srcSet !== "string") return srcSet;
        if (srcSet.trim() == "") return srcSet;
        srcSet = extractSrcSetData(srcSet);
    }
    srcSet = srcSet!
        .filter((sizeItem) => {
            if (sizeItem == null) return false;
            if (sizeItem != null && fixedWidth != null)
                if (fixedWidth < sizeItem.size) return false;
            return true;
        })
        .map((x) => {
            // console.log(
            //     "srcsetLoopMap ",
            //     x.size,
            //     scaleOfScreen,
            //     Math.round(x.size * (1 / scaleOfScreen))
            // );
            return srcSetDataToString({
                url: x.url,
                size:
                    x.unit === "w" && scaleOfScreen > 0
                        ? Math.round(x.size * (1 / scaleOfScreen))
                        : x.size,
                unit: x.unit,
            });
        })
        .concat(fixedWidth != null ? [`${pictureUrl} ${fixedWidth}w`] : [])
        .join(", ");

    return srcSet;
}
